import React from "react";
import { connect } from "react-redux";
import { Switch, Redirect } from "react-router-dom";

//Customs
import PrivateRoute from "../PrivateRoute";

//Selectors
import { isLogged } from "../../store/auth/selectors";

//* ROUTES *//
import CurrentPeriod from "./CurrentPeriod";
import EnjoyVacations from "./EnjoyVacations";

const LegalRoutes = ({ isLogged }) => {
  return (
    <Switch>
      <PrivateRoute
        path="/vacations/current-period"
        component={CurrentPeriod}
        isAuthenticated={isLogged}
      />
      <PrivateRoute
        path="/vacations/enjoy-vacations"
        component={EnjoyVacations}
        isAuthenticated={isLogged}
      />
      <Redirect to="/" />
    </Switch>
  );
};

const mapStateToProps = (state) => ({
  isLogged: isLogged(state),
});

export default connect(mapStateToProps)(LegalRoutes);
